import React from "react";

import axios from "axios";
import Swal from "sweetalert2";

import config from "../../config";

import { List, arrayMove } from "react-movable";
import Footer from "./Footer";
import Header from "./Header";

const Order_allocation_engine = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }

  const [state, setState] = React.useState({});
  const [activestate, setactivestate] = React.useState(0);

  const [packagestate, setpackagestate] = React.useState([]);
  console.log("packagestate ===", packagestate);

  React.useEffect(() => {
    get_customer_detail();
  }, []);
  const get_customer_detail = () => {
    let dataToSend = { customer_id: userData.customer_id };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/get_detail_customer";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          setState(res.data.output);
          if (res.data.output.allocate == 2) {
            setactivestate(2);
            let dataToSend = { customer_id: userData.customer_id };

            // console.log("datatoSend",dataToSend)
            let url = config.apiUrl + "/user/get_customer_carriers";
            axios
              .post(url, dataToSend, { headers: config.headers })
              .then((res) => {
                // console.log("responseJson => ", res);
                if (res.data.status == true) {
                  setpackagestate(res.data.output);
                }
              });
          } else {
            setactivestate(res.data.output.allocate);
          }
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };

  const cheapestactive = () => {
    setactivestate(1);
    setpackagestate([]);
  };

  const customactive = () => {
    setactivestate(2);

    let dataToSend = { customer_id: userData.customer_id };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/get_customer_carriers";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          setpackagestate(res.data.output);
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };

  // const handleItemsReorder = (newOrder) => {
  //   setpackagestate(newOrder);
  // };

  const save_settings = () => {
    let dataToSend = {
      customer_id: userData.customer_id,
      allocate: activestate,
      carriers: packagestate,
    };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/save_allocation_carriers";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          get_customer_detail();

          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#3659cd",
            type: "Success",
            title: "Updated Successfully",
            color: "white",
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };
  const changeStatus = () => {
    let dataToSend = { customer_id: userData.customer_id, allocate: 0 };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/update_allocation_status";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          get_customer_detail();

          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#3659cd",
            type: "Success",
            title: "Updated Successfully",
            color: "white",
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };
  return (
    <div>
      <Header />
      <div class="page-wrapper pinned">
        <div class="main-container">
          <div className="app-container">
            <div class="app-body">
              <div class="container-fluid">
                <div class="mob_nav">
                  <div class=" d-flex justify-content-start ">
                    <a href="javascript:window.history.back();" class="">
                      <i class="bi bi-arrow-left"></i>
                    </a>
                    <h2>Order Allocation Engine</h2>
                  </div>
                </div>

                <div class="row justify-content-between">
                  <div class="col-12 col-md-4 desk_nav">
                    <div class="d-flex">
                      <a
                        href="javascript:window.history.back();"
                        class="back_btn"
                      >
                        <i class="bi bi-arrow-90deg-left"></i>
                      </a>
                      <h2>Order Allocation Engine</h2>
                    </div>
                  </div>
                </div>

                <section class="mb-3 pt-4">
                  <div class="container">
                    <div class="row mb-3">
                      <div class="col-12 col-md">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={(e) => changeStatus(e)}
                        >
                          Click here to Reset
                        </button>
                      </div>
                      |{" "}
                    </div>
                  </div>
                </section>

                <section class=" container mb-3">
                  <div class=" allocation_bx_head">
                    <div class="row justify-content-center py-3">
                      <div class="col-12 col-md-6">
                        <p class="">
                          Please ensure that your search prioritization involves
                          focusing primarily on identifying and selecting
                          couriers.
                        </p>
                      </div>
                    </div>

                    <div class="row justify-content-center ">
                      <div
                        class="col-12 col-md-2"
                        onClick={(e) => cheapestactive()}
                      >
                        <div
                          class="card"
                          style={{
                            border:
                              activestate === 1 ? "2px solid #0d6efd" : "",
                          }}
                        >
                          <div class="card-body">
                            <div class="icon_allo">
                              <img
                                src="../../../assets/img/loss.png"
                                class="img-fluid"
                              />
                            </div>
                            <h5>Cheapest</h5>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-2"
                        onClick={(e) => customactive()}
                      >
                        <div
                          class="card"
                          style={{
                            border:
                              activestate === 2 ? "2px solid #0d6efd" : "",
                          }}
                        >
                          <div class="card-body">
                            <div class="icon_allo">
                              <img
                                src="../../../assets/img/custom.png"
                                class="img-fluid"
                              />
                            </div>
                            <h5>Custom</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section>
                    <div class="row justify-content-center py-3">
                      <div class="col-12 col-md-10">
                        <div class="card my-3 text-center border-0">
                          <div class="card-body">
                            {activestate == 2 ? (
                              <small>
                                Drag and drop the couriers to create a
                                customized priority based on your shipping
                                needs.
                              </small>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        {/* <div class="allocation_bx_content">
                  <div class="card border-0 " style={{background: "#e4edf2",
    marginBottom: "4.5rem"}}>
                    <div class="card-body">
                      <div class="row justify-content-center">
                        {packagestate.map((sub)=>(
                          <div class="col-12 col-md-3 mb-3">
                            <div class="card box_holder" style={{background: "#fff",
    padding: "2rem 1rem",
    textAlign: "center",
    borderRadius: "10px",
    fontSize: "14px"}}>
                              <figure >
                                <img src={`https://cdn.shiprath.com/images/${sub.carrier_image}`} class="img-fluid" height="50px" width="50px" />
                              </figure>
                              <h6>{sub.carrier_name}</h6>
                             
                            </div>
                          </div>
                          ))}
                         
                      </div>
                    </div>
                  </div>
                </div>  */}

                        <div className="allocation_bx_content">
                          <div
                            className="card border-0"
                            style={{
                              background: "#e4edf2",
                              marginBottom: "4.5rem",
                            }}
                          >
                            <div className="card-body">
                              <List
                                values={packagestate}
                                onChange={({ oldIndex, newIndex }) => {
                                  setpackagestate(
                                    arrayMove(packagestate, oldIndex, newIndex)
                                  );
                                }}
                                renderList={({ children, props }) => (
                                  <div {...props}>{children}</div>
                                )}
                                renderItem={({ value, props }) => (
                                  <div
                                    {...props}
                                    className="col-12 col-md-12 mb-3"
                                  >
                                    <div
                                      className="card box_holder handle"
                                      style={{
                                        background: "#fff",
                                        padding: "2rem 1rem",
                                        textAlign: "center",
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <figure>
                                        <img
                                          src={`https://cdn.shiprath.com/images/${value.carrier_image}`}
                                          className="img-fluid"
                                          height="50px"
                                          width="50px"
                                          alt="Carrier"
                                        />
                                      </figure>
                                      <h6>{value.product_name}</h6>
                                    </div>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div class="allocation_bx_footer">
                    <div class="row justify-content-center py-3">
                      <div class="col-12 col-md-4">
                        <div class="d-grid">
                          <a
                            onClick={(e) => save_settings()}
                            class="btn btn-primary btn-block"
                          >
                            Save Settings
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order_allocation_engine;
